<template>
  <div>
    <div>
      <Form :model="searchData" inline>
        <FormItem prop="gas_name">
          <Input type="text" v-model="searchData.gas_name" placeholder="站点名称" class="lx-search-item"></Input>
        </FormItem>
           <FormItem prop="station_id">
          <Input type="text" v-model="searchData.station_id" placeholder="站点id" class="lx-search-item"></Input>
        </FormItem>

        
<!--        <FormItem prop="station_type" label="渠道:" :label-width="60">-->
<!--          <Select v-model="searchData.platform">-->
<!--            <Option value="">全部</Option>-->
<!--            <Option v-for="item in platform" :value="item.id">{{item.name}}</Option>-->
<!--          </Select>-->
<!--        </FormItem>-->
        <FormItem label="省市区：" prop="province" style="width:450px">
          <Select v-model="searchData.province_name" style="width: 25%" placeholder="省" @on-change="changeProvince">
            <Option value="">请选择</Option>
            <Option v-for="(item,key) in provinces" :value="item" :key="key">{{item}}</Option>
          </Select>
          <Select v-model="searchData.city_name" style="width: 25%" placeholder="市" @on-change="changeCity">
            <Option value="">请选择</Option>
            <Option v-for="(item,key) in citys" :value="item" :key="key">{{item}}</Option>
          </Select>
          <Select v-model="searchData.county_name" style="width: 25%" placeholder="区">
            <Option value="">请选择</Option>
            <Option v-for="(item,key) in countys" :value="item" :key="key">{{item}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="doSearch">搜索</Button>
        </FormItem>
        <FormItem style="margin-left:20px">
          <Checkbox
                  :indeterminate="indeterminate"
                  :value="checkAll"
                  @click.prevent.native="checkAllAgentStation">全选</Checkbox>
          <Button type="primary" @click="doSubmit">提交</Button>
        </FormItem>
      </Form>
    </div>

    <div ref="container" class="wrapper">
      <CheckboxGroup v-model="checked" @on-change="editAgentStationInfoChange" class="custom-checkbox">
        <RecycleScroller
                style="height: 700px"
                :items="stations"
                :item-size="36"
                :min-item-size="36"
                key-field="station_id"
                class="scroller"
                :item-key="(item) => item.station_id"
                ref="scroller"
        >
          <template #default="{ item }">
            <div class="row">
              <Checkbox :label="item.station_id" :key="`${item.station_id}-${checked.includes(item.station_id)}`">
                <Tag color="warning">{{item.platform}}</Tag>
                <Tag color="primary">{{item.price2}}</Tag>
                {{item.station_id}}
                {{item.gas_name}}
                <Tag v-if="item.is_use_platform == 1" color="success">不推平台</Tag>
              </Checkbox>
            </div>


          </template>


        </RecycleScroller>
      </CheckboxGroup>
    </div>

<!--    <CheckboxGroup v-model="checked" @on-change="editAgentStationInfoChange" class="custom-checkbox">-->
<!--       <Checkbox v-for="(item,key) in stations" :label="item.station_id" class="row" :key="key" style="width: 45%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis">-->
<!--         <Tag color="warning">{{item.platform}}</Tag>-->
<!--         <Tag color="primary">{{item.price2}}</Tag>-->
<!--         {{item.station_id}}-->
<!--         {{item.gas_name}}-->
<!--       </Checkbox>-->
<!--     </CheckboxGroup>-->



  </div>
</template>

<script>
  import { RecycleScroller } from "vue-virtual-scroller"
  import "vue-virtual-scroller/dist/vue-virtual-scroller.css"
  export default {
    name: "edit",
    components: { RecycleScroller },
    props:{
      id:{
        type:Number,
        default: 0
      },
    },
    data(){
      return {
        searchData:{
          is_search:1,
          gas_name:'',
          platform:'',
          province_name:'',
          city_name:'',
          county_name:'',
          station_id:'',
        },
        platform:[],
        checkAll:false,
        indeterminate: true,
        checked:[],
        originalChecked: [], // 保存原始选中状态
        stations:[],
        allStationID:[],
        province_county_data:[],    //省市区数据
        provinces:[],
        citys:[],
        countys:[],
      }
    },
    methods:{
      async getInfo(){
        // let data = await this.$commonFun.postProxy('admin/common/getPageInitInfo',{type:['platform']})
        if (this.id>0){
          let res = await this.$commonFun.postProxy('admin/agent/getAgentStations',{id:this.id,is_search:0});
          // 统一数据类型为字符串
          this.checked = res.data.checked;
          this.originalChecked = [...this.checked];
          this.allStationID = res.data.all_station_ids;
          this.stations = res.data.stations;
        }


        this.$commonFun.postProxy('admin/tuanyou/getProvince',{}).then((res)=>{
          this.province_county_data = res.data.province_county_data;
          this.provinces = res.data.province_data
        })

        /*if (this.id>0){
          let res = await this.$commonFun.postProxy('admin/agent/getAgentStations',{id:this.id,is_search:0});
          this.checked = res.data.checked
          this.allStationID = res.data.all_station_ids
          this.stations = res.data.stations
        }*/
      },
      changeProvince(province){
        this.citys = []
        this.province_county_data.forEach((item)=>{
          if (item.value === province){
            item.children.forEach(val=>{
              this.citys.push(val.value)
            })
          }
        })
      },
      changeCity(city){
        this.countys=[]
        let province = this.searchData.province_name
        this.province_county_data.forEach((item)=>{
          if (item.value === province){
            item.children.forEach((val)=>{
              if (val.value === city){
                val.children.forEach(val=>{
                  this.countys.push(val.value)
                })
              }
            })

          }
        })
      },
      async doSubmit(){
        // 计算新增的站点（在当前选中但不在原始选中中）
        const added = this.checked.filter(id => !this.originalChecked.includes(id))
        // 计算删除的站点（在原始选中但不在当前选中中）
        const removed = this.originalChecked.filter(id => !this.checked.includes(id))
        let params = {
          id:this.id,
          //checked:this.checked,
          added: added,    // 新增的站点ID数组
          removed: removed // 删除的站点ID数组
        }
        let _self = this
        this.$Modal.confirm({
          content: (this.checked.length<=0) ? '确定要全部下线吗' : '<p>确定提交吗</p>',

          onOk: async () => {
            let res = await _self.$commonFun.postProxy('admin/agent/editAgentStation',params)
            //编辑成功刷新父页面
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip('操作成功',()=>{this.getInfo()})
            })
          },
        });

      },
      async doSearch(){
        this.searchData.id = this.id
        let res = await this.$commonFun.postProxy('admin/agent/getAgentStations',this.searchData)
        this.checked = res.data.checked
        this.allStationID = res.data.all_station_ids
        this.stations = res.data.stations

        // 获取搜索关键词
        const gasNameKeyword = this.searchData.gas_name.toLowerCase()
        const stationIdKeyword = this.searchData.station_id.toLowerCase()
        const selectedProvince = this.searchData.province_name.toLowerCase()
        const selectedCity = this.searchData.city_name.toLowerCase()
        const selectedCounty = this.searchData.county_name.toLowerCase()

        // 检查是否有搜索条件
        const hasSearchCondition = gasNameKeyword || stationIdKeyword || selectedProvince || selectedCity || selectedCounty

        if (hasSearchCondition) {
          // 有搜索条件时，按匹配类型排序
          const gasNameMatches = []            // 站点名称匹配的站点
          const stationIdMatches = []          // 站点ID匹配的站点
          const locationMatches = []           // 省市区匹配的站点
          const noMatch = []                   // 无匹配的站点

          res.data.stations.forEach(item => {
            const gasName = item.gas_name.toLowerCase()
            const stationId = item.station_id.toString().toLowerCase()
            const province = item.province_name ? item.province_name.toLowerCase() : ''
            const city = item.city_name ? item.city_name.toLowerCase() : ''
            const county = item.county_name ? item.county_name.toLowerCase() : ''

            // 检查是否匹配搜索条件，按优先级分类
            const isGasNameMatch = gasName.includes(gasNameKeyword) && gasNameKeyword
            const isStationIdMatch = stationId.includes(stationIdKeyword) && stationIdKeyword
            const isProvinceMatch = province.includes(selectedProvince) && selectedProvince
            const isCityMatch = city.includes(selectedCity) && selectedCity
            const isCountyMatch = county.includes(selectedCounty) && selectedCounty

            if (isGasNameMatch) {
              gasNameMatches.push(item)
            } else if (isStationIdMatch) {
              stationIdMatches.push(item)
            } else if (isProvinceMatch || isCityMatch || isCountyMatch) {
              locationMatches.push(item)
            } else {
              noMatch.push(item)
            }
          })

          // 按优先级合并数组：站点名称匹配在前，然后是站点ID匹配，再是省市区匹配，最后是无匹配
          this.stations = [
            ...gasNameMatches,
            ...stationIdMatches,
            ...locationMatches,
            ...noMatch
          ]
        } else {
          // 没有搜索条件时，将选中的项目放在前面
          const selectedItems = []
          const unselectedItems = []

          res.data.stations.forEach(item => {
            if (this.checked.includes(item.station_id)) {
              selectedItems.push(item)
            } else {
              unselectedItems.push(item)
            }
          })

          this.stations = [...selectedItems, ...unselectedItems]
        }
      },
      editAgentStationInfoChange (data) {
        if (data.length === this.stations.length) {
          this.indeterminate = false;
          this.checkAll = true;
        } else if (data.length > 0) {
          this.indeterminate = true;
          this.checkAll = false;
        } else {
          this.indeterminate = false;
          this.checkAll = false;
        }
      },
      checkAllAgentStation(){
        this.checkAll = this.checked.length !== this.stations.length
        this.indeterminate = false;
        console.log(this.checkAll)
        if (this.checkAll) {
          this.checked = this.allStationID;
        } else {
          this.checked = [];
        }
      },

    },
    mounted() {
      this.getInfo()
    },
  }
</script>

<style scoped lang="less">

  .wrapper {
    height: 700px;
    overflow-y: auto;
  }
  .custom-checkbox .scroller {
    //display: flex;
    //flex-wrap: wrap;
    height: 700px !important; /* 确保scroller有固定高度 */
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* 两列布局 */
    grid-auto-rows: 36px; /* 每行高度与item-size一致 */
    gap: 2px;
  }
  .row {
    //box-sizing: border-box;
    //margin: 2px;
    //white-space: nowrap;
    //overflow: hidden;
    //text-overflow: ellipsis;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center; /* 垂直居中对齐 */
    height: 32px; /* 略小于grid-auto-rows设置的高度，为gap留空间 */
    padding: 0 4px;
  }

  .drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }

  .info-item{
    >span:nth-child(1){
      min-width: 100px;
      display: inline-block;
      text-align: right;
      letter-spacing: 2px;
      padding: 2px;
    }
    >span:nth-child(2){
      display: inline-block;
      padding-left: 10px;
    }
    .important-word{
      font-weight: bold;
      color: red;
    }
  }

  .provinceCol{
    text-align: center;
    p{
      padding: 5px 0;
      cursor: pointer;
    }
  }

</style>
